// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  changeUrl: true,
  app_url: 'https://pmi.ramconsulting.it/',
  api_url: 'api/',
  api_rischiocambio_url: 'services/rischiocambio/api/',
  appVersion: require('../../package.json').version,
  supportedLanguages: ['it', 'gb'],
  qlik_host: 'qlik.pmi.ramconsulting.it',
  qlik_port: '443',
  reload_cambi_interval: 20
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
